import type {
	HelpCenterArticle,
	HelpCenterArticleTranslation,
	HelpCenterGroup,
	HelpCenterGroupTranslation,
} from "@productlane/zero"

import type { Language } from "@/screens/settings/settings-pages/language-selector"
import {
	useHelpCenterArticleTranslations,
	useHelpCenterGroupTranslations,
} from "@/lib/use-item-translations"
import { getArticleDisplayTitle } from "./article-kind"

type HelpCenterArticleWithTranslations = HelpCenterArticle & {
	translations?: readonly HelpCenterArticleTranslation[]
}

type HelpCenterGroupWithTranslations = HelpCenterGroup & {
	translations?: readonly HelpCenterGroupTranslation[]
}

export function HelpCenterArticleTitleWithTranslation({
	article,
	selectedLanguage,
}: {
	article: HelpCenterArticleWithTranslations
	selectedLanguage: Language
}) {
	const { selectedTranslation } = useHelpCenterArticleTranslations(
		article,
		selectedLanguage,
	)
	return <>{getArticleDisplayTitle(article, selectedTranslation.title)}</>
}

export function HelpCenterArticleSummaryWithTranslation({
	article,
	selectedLanguage,
}: {
	article: HelpCenterArticleWithTranslations
	selectedLanguage: Language
}) {
	const { selectedTranslation } = useHelpCenterArticleTranslations(
		article,
		selectedLanguage,
	)
	return <>{selectedTranslation.summary || article.summary || "Summary"}</>
}

export function HelpCenterGroupTitleWithTranslation({
	group,
	selectedLanguage,
}: {
	group: HelpCenterGroupWithTranslations
	selectedLanguage: Language
}) {
	const { selectedTranslation } = useHelpCenterGroupTranslations(
		group,
		selectedLanguage,
	)
	return <>{selectedTranslation.title || group.name}</>
}
